export interface MapTarget {
  latitude: number;
  longitude: number;
  statusId?: number;
}

const isValidLatitude = (value: number) => Number.isFinite(value) && value >= -90 && value <= 90;
const isValidLongitude = (value: number) => Number.isFinite(value) && value >= -180 && value <= 180;

export const buildMapLink = (target: MapTarget): string => {
  const params = new URLSearchParams({
    lat: String(target.latitude),
    lng: String(target.longitude),
  });
  if (target.statusId && Number.isInteger(target.statusId) && target.statusId > 0) {
    params.set('status', String(target.statusId));
  }
  return `/app?${params.toString()}`;
};

export const parseMapTarget = (search: string): MapTarget | null => {
  const params = new URLSearchParams(search);
  const latitude = Number(params.get('lat'));
  const longitude = Number(params.get('lng'));
  if (!params.has('lat') || !params.has('lng') || !isValidLatitude(latitude) || !isValidLongitude(longitude)) {
    return null;
  }

  const rawStatusId = params.get('status');
  const statusId = rawStatusId == null ? undefined : Number(rawStatusId);
  return {
    latitude,
    longitude,
    ...(statusId && Number.isInteger(statusId) && statusId > 0 ? { statusId } : {}),
  };
};
